import { ManufacturerModel } from "../../models/manufacturer-model";
import { Table } from "../../models/table";
import { PriceFieldType } from "./PrintFieldValue.types";

/**
 * returns the symboll shekel with the value, if this is a price field
 * @param field_name 
 * @param value 
 */
export function addShekelSymbol<T>(field_name: string, value: T): string | T {

    const priceFieldsNames: PriceFieldType[] = ["price", "total", "net", "cost"];

    if (typeof value === "string" || typeof value === "number") {
        return priceFieldsNames.includes(field_name as PriceFieldType) ? `${value}₪` : value;
    }

    return value;
}

/**
 * filter models by manufacturer
 * @param models 
 * @param manufacturers 
 * @param manufacturerIndex 
 */
export function getManufacturerModels( models: ManufacturerModel[], manufacturers: Table[], manufacturerIndex: number ): ManufacturerModel[] {

    const manufacturer_id = manufacturers?.[manufacturerIndex - 1].id;
    return models.filter(model => model.manufacturer_id === manufacturer_id);

}